import JSZip from 'jszip';
import {
  DocumentFormat,
  FlightBriefingParams,
  PacketTypeOption,
} from '../@types/FlightBriefing.type';

const MIME_TYPES: Record<DocumentFormat | 'ZIP', string> = {
  PDF: 'application/pdf',
  XML: 'application/xml',
  ZIP: 'application/zip',
};

const flightPrefix = (params: FlightBriefingParams) =>
  [
    `${params.operatingAirline}${params.flightNumber}`,
    `${params.origin}-${params.destination}`,
    params.scheduledOperatingDateUTC,
  ]
    .join('_')
    .toUpperCase();

/** e.g. AS70_ANC-JNU_2026-10-29_pdf-weather-briefing.pdf */
export const buildDocumentFileName = (
  params: FlightBriefingParams,
  packetType: PacketTypeOption,
): string =>
  `${flightPrefix(params)}_${packetType.value}.${packetType.format.toLowerCase()}`;

/** e.g. AS70_ANC-JNU_2026-10-29_FlightBriefing.zip */
export const buildZipFileName = (params: FlightBriefingParams): string =>
  `${flightPrefix(params)}_FlightBriefing.zip`;

export const withMimeType = (blob: Blob, format: DocumentFormat | 'ZIP') => {
  const type = MIME_TYPES[format];
  return blob.type === type ? blob : new Blob([blob], { type });
};

/** Packages the given files into a single ZIP blob. */
export const createZip = async (
  files: { fileName: string; blob: Blob }[],
): Promise<Blob> => {
  const zip = new JSZip();
  files.forEach(({ fileName, blob }) => zip.file(fileName, blob));
  return zip.generateAsync({ type: 'blob', mimeType: MIME_TYPES.ZIP });
};

/** Triggers a browser download for the given blob. */
export const saveBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
